import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataquealityCheckformComponent } from './dataqueality-checkform.component';


const routes: Routes = [
  {
    path: '',
    component: DataquealityCheckformComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataquealityCheckformRoutingModule {}